$(document).ready(function(){ 
 function recurse() {
        if ( $(".wc_wf_cls .wc_slider_start_li").length > 1 ) {        
              $('.wc_testimonial_inner .wc_testi_content').matchHeight();
          } else {
            recurse();
          }
    }
  setTimeout(function(e){
    // recurse();
  },14000);
  
$('select.color__swatch_select').on('change', function(){
console.log('changed')
  // var optionSelected = $(this).find('option');
  var valueSelected = $(this).val();
  $('.color__varient').prop("value", valueSelected);

  if($("select.color__swatch_select option[data-attr-avai='available']")) {
    $('.sticky_product_cart_wrapper .product-form__submit span').text("add to cart");
    $('.sticky_product_cart_wrapper .product-form__submit').removeAttr("disabled");
  }
});
  
  
  // $('.card-information .price__sale').matchHeight();
  // $('.new_card_media img').matchHeight();

  //=============== hero-banner slider js==================== // 
  // var main_slider_speed = $('.wc-hero-banner').data("slider_speed");
  // var main_slider_autoplay = $('.wc-hero-banner').data("autoplay");
  // if($('.wc-hero-banner li').length > 1){
  //   $('.wc-hero-banner').slick({
  //     dots: true,
  //     infinite: true,
  //     slidesToShow: 1,
  //     adaptiveHeight: true,
  //     autoplay: true,
  //     autoplaySpeed: main_slider_autoplay,
  //     speed: main_slider_speed
  //   });
  // }
  $(document).ready(function(){ 
  var quality_block_speed = $('.wc-quality_block').data("speed");
  var quality_block_autoplay = $('.wc-quality_block').data("autoplay");
   $('.wc-quality_block').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: quality_block_autoplay,
    speed: quality_block_speed,
     responsive:[
         {
           breakpoint : 779,
           settings:{
           		slidesToShow: 2
           	}
         },
         {
           breakpoint : 575,
           settings:{
           	 slidesToShow: 1,
             centerMode:false,
             infinite: false,
             autoplay:true,
             speed: 200,
             dots:true
           	}
         }
       ]
  });

   }); 
  
  
//   ================  product type js ===============================//
  
  
  // if ((window.innerWidth <= 1090 ))  {
  //    $('.wc-type').slick({
  //     dots: false,
  //     infinite: true,
  //     speed: 300,
  //     slidesToShow: 4,
  //     autoplay: true,
  //     arrows:false,
  //     autoplaySpeed: 2000,
  //     speed: 1000,
  //     slide: 'li',
  //      responsive:[
  //        {
  //          breakpoint : 774,
  //          settings:{
  //          		slidesToShow: 3
  //          	}
  //        },
  //        {
  //          breakpoint : 582,
  //          settings:{
  //          		slidesToShow: 2
  //          	}
  //        }
  //      ]
  //   });
  //   $('.wc-type').removeClass('row')
  // }else{
  // 	$('.wc-type').addClass('row')
  // }

  
//   ================== new featured collection js =================//
  // var slider_speed = $('.wc-featured-collection').data("speed");
  // var slider_autoplay = $('.wc-featured-collection').data("autoplay");
  // $('.wc-featured-collection').slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   adaptiveHeight: false,
  //   autoplay: true,
  //   slidesToScroll: 2,
  //   autoplaySpeed: slider_autoplay,
  //   speed: slider_speed,
  //   responsive:[
  //     {
  //       breakpoint : 1441,
  //       settings:{
  //         slidesToShow: 3,
  //       	slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint : 992,
  //       settings:{
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint : 576,
  //       settings:{
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows:false,
  //         speed:300,
  //         dots:true
  //       }
  //     }
  //   ]
  // });
  
// ACTIVITY SECTION SLIDER JS  
  $('.multiple-items').slick({
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        slidesToScroll: 1,
        speed: 1000,
        dots: true,
        arrows:false
      }
    }
  ]
  });
//    $('.multiple-items ').slick('slickGoTo',"1");
  
//   footer_top_types js
    if ((window.innerWidth <= 1000))  {
     $('.foter-top-info').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      autoplay: true,
      arrows:false,
      autoplaySpeed: 2000,
      speed: 1000,
       responsive:[
         {
           breakpoint : 576,
           settings:{
           		slidesToShow: 2
           	}
         }
        ]
    });
  }

// coillection page addto cart ajax
  $('.grid_color_swatch .chnage_color_swatch').change(function(){
    $(this).parents('.swatch').find('.swatch-element').removeClass('active')
    $(this).parent().addClass('active');
    var variant_id = $(this).parents('.card_new_product_main_card').find('.color.active').data("id");
    $('.add_cart_product').attr('data-id',variant_id)
  });
  
//   function addItem(variant_id,get_cart) {
//       var quantity = quantity || 1;
//       var params = {
//         type: 'POST',
//         url: '/cart/add.js',
//         data: 'quantity=' + 1 + '&id=' + variant_id,
//         dataType: 'json',
//         success: function(line_item) { 
//           $(get_cart).text('added');
//           jQuery.getJSON('/cart.js', function(cart) {
//             console.log('cart-count-bubble',cart.item_count)
//               $('.cart-count-bubble span').text(cart.item_count);
//           });
//         },
//         error: function(XMLHttpRequest, textStatus) {
//           Shopify.onError(XMLHttpRequest, textStatus);
//           console.log(textStatus);
//         }
//       };
//       jQuery.ajax(params);
//     };
  
//   $('.product-form__submit').on('click',function(e){
//     e.preventDefault();
//     if($(this).parents('.card_new_product_main_card').find('.color.active').data("id") == undefined){
//       var variant_id = $(this).data("id");    
//     }else{
//       var variant_id = $(this).parents('.card_new_product_main_card').find('.color.active').data("id");
//     }
//     var this_one = $(this);
//     setTimeout(function(){
//       addItem(variant_id,this_one);
//     }, 1500);
//   });
// product page media slider starts from here
  /*$('.wc-product_media_div').slick({
    nextArrow: '.wc-slick-next',
    prevArrow: '.wc-slick-prev'
  });*/

  $('.wc-product_media_div').slick({
    /*nextArrow: '.wc-slick-next',
    prevArrow: '.wc-slick-prev',*/
    asNavFor: '.wc-product_media',
    fade: true,
    arrows: false,
    speed: 300,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          dots: true
        }
      }
    ]
  });

  $('.wc-product_media').slick({
    nextArrow: '.wc-slick-next',
    prevArrow: '.wc-slick-prev',
    slidesToShow: 7,
    slidesToScroll: 7,
    speed: 300,
    asNavFor: '.wc-product_media_div',
    vertical: true,
    focusOnSelect: true,
    loop: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  if ($(window).width() > 769) {
    $('.wc-product_media').on('mouseover', '.slick-slide', function (e) {
      
      var $currTarget = $(e.currentTarget), 
      index = $currTarget.data('slick-index'),
      slickObj = $('.wc-product_media_div').slick('getSlick');
      // console.log(index)
      slickObj.slickGoTo(index);
      
    });
  }
  
//   $('input[type="radio"]').each(function(){
//     var input_color_val  = $(this).val();
//     $(this).next().css( "background-color", input_color_val );
//   });
  
  
  $('#play_button').on('click',function(){
    if ((window.innerWidth >= 576 )){
      $(this).parent('.video_par').find('.desktop__video').trigger('play')
      $(this).parent('.video_par').find('.desktop__video').attr('controls','')
      $(this).hide();
    }
  });
  $('#play_button').on('click',function(){
    if ((window.innerWidth <= 575 )){
      $(this).parent('.video_par').find('.mobile__video').trigger('play')
      $(this).parent('.video_par').find('.mobile__video').attr('controls','')
      $(this).hide();
    }
  });
  
  
//   product page product feataures slider starts from here
  
  if ((window.innerWidth <= 992 ))  {
    if($('.product_page_featurs li').length > 1){
     $('.product_page_featurs').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      autoplay: true,
      arrows:false,
      autoplaySpeed: 2000,
      speed: 1000,
      slide: 'li',
       responsive:[
         {
           breakpoint : 774,
           settings:{
           		slidesToShow: 2
           	}
         }
       ]
    });
  }else{
      $('.product_page_featurs').hide();
  }
  }
  
    
//   if ((window.innerWidth <= 768 ))  {
//      $('.product_galary_clider').slick({
//       dots: true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 2,
//       autoplay: true,
//       arrows:false,
//       autoplaySpeed: 2000,
//       speed: 1000,
//        responsive:[
//          {
//            breakpoint : 575,
//            settings:{
//              slidesToShow: 1,
//              centerMode:true,
//              infinite: false,
//              autoplay: false
//            }
//          }
//        ]
//     });
//   }
  

                  
 $(".marquee__inner").slick({
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 0,
  variableWidth: true,
  cssEase: 'linear',
  slidesToShow: 7,
  slidesToScroll: 1,
  infinite: true,
  arrows: false,
  swipeToSlide: true,
  centerMode: true,
  focusOnSelect: true,
  pauseOnHover:true,
  responsive: [
    {
      breakpoint: 1740,
      settings:{
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1441,
      settings:{
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }
  ]
});
if( $('.compney_partner_inner').length > 1 ){
  $('.slider').slick({
  infinite: true,
  arrows: true,
  dots: false,
  autoplay: true,
  adaptiveHeight: true,
  speed: 1050,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
    responsive : [
          {
      breakpoint: 990,
      settings:{
      arrows: false,
      }
    }
    ]
  });
}

    var percentTime;
    var tick;
    var time = .1;
    var progressBarIndex = 0;

    $('.progressBarContainer .progressBar').each(function(index) {
        var progress = "<div class='inProgress inProgress" + index + "'></div>";
        $(this).html(progress);
    });

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 10);
    }

    function interval() {
        if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
            progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
            startProgressbar();
        } else {
            percentTime += 1 / (time + 5);
            $('.inProgress' + progressBarIndex).css({
                width: percentTime + "%"
            });
            if (percentTime >= 100) {
                $('.single-item').slick('slickNext');
                progressBarIndex++;
                if (progressBarIndex > 2) {
                    progressBarIndex = 0;
                }
                startProgressbar();
            }
        }
    }

    function resetProgressbar() {
        $('.inProgress').css({
            width: 0 + '%'
        });
        clearInterval(tick);
    }
    startProgressbar();
    // End ticking machine

    $('.item').click(function () {
    	clearInterval(tick);
    	var goToThisIndex = $(this).find("span").data("slickIndex");
    	$('.single-item').slick('slickGoTo', goToThisIndex, false);
    	startProgressbar();
    });

 $('.blog_tranding_slick').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 1000,
   	arrow:true,
       responsive:[
          {
           breakpoint : 768,
           settings:{
           	slidesToShow: 2,
             centerMode:false,
             infinite: true,
             autoplay:false,
             dots:false,
             arrow:false,
           	}
         },
         {
           breakpoint : 575,
           settings:{
           	slidesToShow: 1,
             centerMode:false,
             infinite: true,
             autoplay:false,
             dots:true,
             arrow:false,
           	}
         }
       ]
  });
  
  var windowSize = $(window).width();
  // console.log(windowSize)
  if (windowSize >= 991){
    __optimize.script.after('jquery.zoom.min.js', function(){
      $('.image-zoom')
      .wrap('<span style="display:block"></span>')
      .css('display', 'block')
      .parent()
      .zoom({
        url: $(this).find('img').attr('data-zoom')
      });
    }, {
      user:{
      interaction:true
      }
    });
  }
  

  


// function myFunction(event){
//     event.preventDefault();
//     var cartsectipon = document.querySelector('cart-notification');
//     cartsectipon.setActiveElement(document.activeElement);
//     var id = event.target.getAttribute('data-id');
//     var qty = event.target.getAttribute('data-qty');
//     const config = fetchConfig('javascript');
//     config.headers['X-Requested-With'] = 'XMLHttpRequest';
//     delete config.headers['Content-Type'];
//     const formData = new FormData();

//     formData.append('sections', cartsectipon.getSectionsToRender().map((section) => section.id));
//     formData.append('sections_url', window.location.pathname);
//     formData.append('id', id);
//     formData.append('quantity', qty);
//     config.body = formData;

//     fetch(`${routes.cart_add_url}`, config)
//     .then((response) => response.json())
//     .then((response) => {
//       cartsectipon.renderContents(response);
//     })
//     .catch((e,t) => {
//       console.error(e,t);
//     })
//     .finally(() => { });
//   }
setTimeout(function(e){
  $('.swatch_details').matchHeight();
  $('.collection .grid__item .card__heading a').matchHeight();
},500)


$(document).on("click",".variant__input--color-swatch",function() {
  var curVal = $(this).val();
  $('.selectselect_color > option').removeAttr('selected','selected');
  $(".selectselect_color > option").each(function() {
    var selVal = this.value
    if(curVal == selVal ){
      $(this).attr('selected','selected');
    }
  });
});




document.getElementById("Details-HeaderMenu-2").addEventListener("mouseover", function(e){
  this.setAttribute("open","");
});
document.getElementById("Details-HeaderMenu-2").addEventListener("mouseout", function(e){
 this.removeAttribute("open","");

});

// footer Accodion
    var mobsize = $(window).width();
   
    if (mobsize <= 575){
     // console.log("if-true")
        $(".footer-block--menu .footer-block__heading").click(function(){
        $(this).toggleClass("active");
        $(this).parent().find(".footer-block__details-content").toggle("slow");
        $(this).parent(".footer-block--menu").siblings().find(".footer-block__details-content").not(':first').hide("slow");
        $(this).parent(".footer-block--menu").siblings().find(".footer-block__heading").removeClass("active");
        });
    }

// });




$(".variant_values label").on('click', function(){
  var filter = $(this).data('tooltip');
  // console.log(filter)
  $(".wc-product_media").slick('slickUnfilter');
  $(".wc-product_media_div").slick('slickUnfilter');
  
  $('.variant_values label').each(function () {
    var data_title = $(this).attr('data-title');
    // console.log(data_title)
    if (data_title == filter) {
      $(".wc-product_media").slick('slickFilter','.'+filter);
      $(".wc-product_media_div").slick('slickFilter','.'+filter);
      
      $(".wc-product_media").slick('refresh');
      $(".wc-product_media_div").slick('refresh');
    }
    
  });

  
  if ($('.wc-product_media li').length <= 8) {
    $('.wc-product_media .slick-arrow').hide();
  } else {
    $('.wc-product_media .slick-arrow').show();
  }
  
  /*if(filter == 'all'){
    $(".slider").slick('slickUnfilter');
  }*/
  
});

      $(document).ready(function() {
      var load_filter = $('.product-form__input input[type="radio"]:checked').data('tooltip');
      //console.log(load_filter, 'filter')
      
      $('.variant_values label').each(function () {
        var load_data_title = $(this).attr('data-tooltip');
        //console.log(load_data_title, 'load-filter')
      
        if (load_data_title == load_filter) {
          setTimeout(function() {
            $(".grid_w-30 .wc-product_media").slick('slickFilter','.'+load_filter);
            $(".grid_w-70 .wc-product_media_div").slick('slickFilter','.'+load_filter);
            
            $(".grid_w-30 .wc-product_media").slick('refresh');
            $(".grid_w-70 .wc-product_media_div").slick('refresh');
          }, 700);
        }
        
      });
      
      setTimeout(function() {
        if ($('.wc-product_media li').length <= 8) {
          $('.wc-product_media .slick-arrow').hide();
        } else {
          $(' .wc-product_media .slick-arrow').show();
        }
      }, 700);
      
      });
// In a home page testimonial section all col same height


    });
